import { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { getStatus } from "@/store/slices/helpers/helpers";
import { clearData, fetchData } from "@/store/slices/fetch-slice";
import { apiKeys, apiMethods, apiUrls } from "@/store/api/constants";
import navs from "@/from-theme/routes/constants/nav";
import { useNavigate } from "react-router";
import { getEncoded } from "@/common/helpers/helpers";

export default function useOnActions() {

  const [isAlertDialog, setIsAlertDialog] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((store) => store);

  const deleteMenuAccessStatus = getStatus(state, apiKeys.deleteMenuAccess, '');

  const onCloseAlert = useCallback(() => {
    setIsAlertDialog((prevState) => !prevState);
    setCurrentRowId(null);
  }, []);

  const onAgreeAlert = useCallback(() => {
    dispatch(fetchData({
      url: apiUrls.deleteMenuAccess(currentRowId),
      method: apiMethods.DELETE,
      key: apiKeys.deleteMenuAccess,
      successMsg: formatMessage({ id: "product-master-has-been-deleted-successfully" }),
      failureMsg: formatMessage({ id: "failed-to-delete-product-master" }),
    }))
    onCloseAlert();
  }, [dispatch, formatMessage, onCloseAlert, currentRowId]);


  const onRowDelete = useCallback((id) => {
    setCurrentRowId(id);
    setIsAlertDialog(true);
  }, []);

  const onRowEdit = useCallback((id) => {
    navigate(navs.getEditMenuAccess(getEncoded(id)))
  }, [navigate])


  useEffect(() => () => {
    dispatch(clearData({ key: apiKeys.deleteMenuAccess }));
  }, [dispatch]);


  return useMemo(() => ({
    onRowEdit,
    onRowDelete,
    deleteMenuAccessStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,

  }), [
    onRowEdit,
    onRowDelete,
    deleteMenuAccessStatus,
    isAlertDialog,
    onCloseAlert,
    onAgreeAlert,
  ])
}
